<template>
  <v-card style="min-height: 80vh" elevation="0">
    <loader style="padding-top: 40vh" v-if="showLoader" />
    <VCol class="px-0" v-else>
      <VCol
        cols="12"
        style="text-align: center"
        class="px-0 py-0"
        v-if="$vuetify.breakpoint.xs"
      >
        <v-text-field
          v-model="search"
          dense
          outlined
          clearable
          :label="'transactions_search' | localize"
          placeholder="Start typing.."
        />
        <VRow no-gutters align="center">
          <VCol cols="7">
            <v-select
              type="number"
              outlined
              dense
              color="#27AAE1"
              :items="sortByItems"
              :item-text="(item) => item.title | localize"
              :item-value="'value'"
              :label="'sort_by_placeholder' | localize"
              v-model="sortBy"
            >
              <template v-slot:selection="{ item }">
                {{ item.title | localize }}
              </template>
              <template v-slot:item="{ item }">
                {{ item.title | localize }}
              </template>
            </v-select>
          </VCol>
          <v-spacer></v-spacer>
          <VCol cols="4">
            <v-select
              type="number"
              color="#27AAE1"
              :value="itemsPerPage"
              :items="showEntries"
              @input="itemsPerPage = parseInt($event, 10)"
              outlined
              dense
              :label="'transactions_show_entries' | localize"
            />
          </VCol>
        </VRow>
      </VCol>
      <VRow v-else align="center" class="px-2">
        <VRow align="center" class="px-5">
          <h4 v-if="!$vuetify.breakpoint.xs">
            {{ "transactions_show_entries" | localize }}
          </h4>
          <VCol cols="5" md="3" xl="3" lg="3" sm="3" class="mt-5">
            <v-autocomplete
              type="number"
              :value="itemsPerPage"
              :items="showEntries"
              @input="itemsPerPage = parseInt($event, 10)"
              outlined
              dense
            />
          </VCol>
        </VRow>
        <VRow align="center" class="mb-5 px-3">
          <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
          <h4 v-if="!$vuetify.breakpoint.xs">
            {{ "transactions_search" | localize }}
          </h4>
          <VCol cols="9" md="6" xl="6" lg="6" sm="4">
            <v-text-field
              v-model="search"
              dense
              outlined
              hide-details
              clearable
              @input="getAllQueue"
            />
          </VCol>
        </VRow>
      </VRow>
      <!-- DESKTOP VERSION -->
      <v-data-table
        :headers="headers"
        :items="pending"
        :search="search"
        :items-per-page="itemsPerPage"
        hide-default-footer
        hide-default-header
        :no-data-text="'datatable_empty_table' | localize"
        :no-results-text="'datatable_zero_records' | localize"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :page.sync="page"
        v-if="!$vuetify.breakpoint.xs"
      >
        <template v-slot:header="{ props }">
          <th
            @click="
              !head.sortable && head.sortable !== false
                ? (sortBy = head.value)((sortDesc = !sortDesc))
                : ''
            "
            v-for="head in props.headers"
            :key="head.id"
            style="padding-left: 15px"
          >
            <VRow
              no-gutters
              align="center"
              :justify="head.align ? head.align : 'start'"
              ><output
                style="
                  font-size: 14px;
                  padding-right: 5px;
                  cursor: pointer;
                  user-select: none;
                  margin-bottom: 5px;
                "
                >{{ head.text }}
                <VIcon
                  small
                  v-if="
                    sortBy == head.value &&
                    !sortDesc &&
                    !head.sortable &&
                    head.sortable !== false
                  "
                  :color="head.value == sortBy ? 'black' : ''"
                  >mdi-arrow-up</VIcon
                ><VIcon
                  small
                  v-else-if="!head.sortable && head.sortable !== false"
                  :color="head.value == sortBy ? 'black' : ''"
                  >mdi-arrow-down</VIcon
                ></output
              >
            </VRow>
          </th></template
        >
        <template v-slot:item.status="{ item }">
          <VIcon color="success" v-if="item.status === 'Success'">
            mdi-check-circle
          </VIcon>
          <VIcon color="error" v-if="item.status === 'Refunded'">
            mdi-close-circle
          </VIcon>
          <VIcon color="#B4A30A" v-if="item.status === 'Waiting'">
            mdi-reload
          </VIcon>
        </template>
        <template v-slot:item.created_at="{ item }">
          {{
            new Date(item.created_at).toLocaleDateString(
              loggedUser.locale === "en" ? "en-EN" : "es-ES",
              {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
              }
            )
          }}
        </template>
      </v-data-table>
      <!-- MOBILE VERSION -->
      <v-data-table
        v-else
        :headers="headers"
        :items="pending"
        :search="search"
        :items-per-page="itemsPerPage"
        hide-default-footer
        :no-data-text="'datatable_empty_table' | localize"
        :no-results-text="'datatable_zero_records' | localize"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :page.sync="page"
        class="mobileDataTable"
        style="overflow-x: hidden"
      >
        <template v-slot:item.uid="{ item }">
          <div
            :class="{ 'pending-label': $vuetify.breakpoint.smAndDown }"
            style="
              font-weight: 600;
              font-size: 12px;
              line-height: 14px;
              color: #000000;
              text-align: left;
            "
          >
            {{ item.uid }}
          </div>
        </template>
        <template v-slot:item.amount="{ item }">
          <div
            :class="{ 'pending-label': $vuetify.breakpoint.smAndDown }"
            style="
              font-weight: 600;
              font-size: 12px;
              line-height: 14px;
              color: #000000;
              text-align: left;
            "
          >
            {{ item.amount }}
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <VRow
            no-gutters
            align="center"
            v-if="item.status === 'Success'"
            :class="{ 'pending-label': $vuetify.breakpoint.smAndDown }"
          >
            <span
              style="
                font-weight: 600;
                font-size: 12px;
                line-height: 14px;
                color: #000000;
                margin-right: 8px;
              "
              >{{ "pending_status_accepted" | localize }}</span
            >
            <VIcon color="#2BD050" size="16px"> mdi-check-circle </VIcon>
          </VRow>
          <VRow
            no-gutters
            align="center"
            v-if="item.status === 'Refunded'"
            :class="{ 'pending-label': $vuetify.breakpoint.smAndDown }"
          >
            <span
              style="
                font-weight: 600;
                font-size: 12px;
                line-height: 14px;
                color: #000000;
                margin-right: 8px;
              "
              >{{ "transaction_status_refunded" | localize }}</span
            >
            <VIcon color="#DC566A" size="16px"> mdi-close-circle </VIcon>
          </VRow>
          <VRow
            no-gutters
            align="center"
            v-if="item.status === 'Waiting'"
            :class="{ 'pending-label': $vuetify.breakpoint.smAndDown }"
          >
            <span
              style="
                font-weight: 600;
                font-size: 12px;
                line-height: 14px;
                color: #000000;
                margin-right: 8px;
              "
              >{{ "transaction_status_waiting" | localize }}</span
            >
            <img src="@/assets/img/reloadIcon.svg" />
          </VRow>
        </template>
        <template v-slot:item.code="{ item }">
          <div
            :class="{ 'pending-label': $vuetify.breakpoint.smAndDown }"
            style="
              font-weight: 600;
              font-size: 12px;
              line-height: 14px;
              color: #000000;
              text-align: left;
            "
          >
            {{ item.code }}
          </div>
        </template>
        <template v-slot:item.created_at="{ item }">
          <div
            :class="{ 'pending-label': $vuetify.breakpoint.smAndDown }"
            style="
              font-weight: 600;
              font-size: 12px;
              line-height: 14px;
              color: #000000;
              text-align: left;
            "
          >
            {{
              new Date(item.created_at).toLocaleDateString(
                loggedUser.locale === "en" ? "en-EN" : "es-ES",
                {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                }
              )
            }}
          </div>
        </template>
      </v-data-table>
      <v-pagination
        v-model="page"
        :length="parseInt(pageCount)"
        :color="$vuetify.breakpoint.xs ? '#27AAE1' : '#72AFE7'"
        class="mt-5"
      />
    </VCol>
  </v-card>
</template>

<script>
import QueueService from "@/requests/Business/QueueService";
import { mapGetters } from "vuex";
import Loader from "../../UI/Loader.vue";
export default {
  components: { Loader },
  data: () => ({
    search: "",
    sortBy: "created_at",
    sortDesc: true,
    itemsPerPage: 10,
    page: 1,
    pageCount: 3,
    showEntries: [10, 25, 50, 100],
    showLoader: true,
    headersEs: [
      {
        text: "Id de transacción",
        align: "start",
        value: "uid",
      },
      { text: "Cantidad", value: "amount" },
      { text: "Estado", value: "status" },
      { text: "Codigo", value: "code" },
      { text: "Hora/Fecha", value: "created_at" },
    ],
    headersEn: [
      {
        text: "Transaction id",
        align: "start",
        value: "uid",
      },
      { text: "Amount", value: "amount" },
      { text: "Status", value: "status" },
      { text: "Code", value: "code" },
      { text: "Time/Date", value: "created_at" },
    ],
    sortByItems: [
      {
        id: 1,
        title: "transaction_user",
        value: "uid",
      },
      {
        id: 2,
        title: "transaction_amount",
        value: "amount",
      },
      {
        id: 3,
        title: "transactions_status",
        value: "status",
      },
      {
        id: 4,
        title: "transactions_code",
        value: "name",
      },
      {
        id: 5,
        title: "transactions_created",
        value: "created_at",
      },
    ],
    headers: [],
    pending: [],
  }),
  mounted() {
    this.getAllQueue();
    this.setHeader();
  },
  methods: {
    async getAllQueue() {
      try {
        let response = await QueueService.getAllQueue(this.$route.params.bid);
        this.pending = response.result;
        this.pageCount = response.result.length / this.itemsPerPage + 1;
        this.showLoader = false;
      } catch (e) {
        this.showLoader = false;
      }
    },
    setHeader() {
      if (this.$vuetify.breakpoint.xs) {
        (this.headersEs = [
          {
            text: "Id de transacción",
            align: "start",
            value: "uid",
            sortable: false,
          },
          { text: "Cantidad", value: "amount", sortable: false },
          { text: "Estado", value: "status", sortable: false },
          { text: "Codigo", value: "code", sortable: false },
          { text: "Hora/Fecha", value: "created_at", sortable: false },
        ]),
          (this.headersEn = [
            {
              text: "Transaction id",
              align: "start",
              value: "uid",
              sortable: false,
            },
            { text: "Amount", value: "amount", sortable: false },
            { text: "Status", value: "status", sortable: false },
            { text: "Code", value: "code", sortable: false },
            { text: "Time/Date", value: "created_at", sortable: false },
          ]);
      } else {
        (this.headersEs = [
          {
            text: "Id de transacción",
            align: "start",
            value: "uid",
            sortable: false,
          },
          { text: "Cantidad", value: "amount", sortable: false },
          { text: "Estado", value: "status", sortable: false },
          { text: "Codigo", value: "code", sortable: false },
          { text: "Hora/Fecha", value: "created_at", sortable: false },
        ]),
          (this.headersEn = [
            {
              text: "Transaction id",
              align: "start",
              value: "uid",
              sortable: false,
            },
            { text: "Amount", value: "amount", sortable: false },
            { text: "Status", value: "status", sortable: false },
            { text: "Code", value: "code", sortable: false },
            { text: "Time/Date", value: "created_at", sortable: false },
          ]);
        (this.headersEs = [
          {
            text: "Id de transacción",
            align: "start",
            value: "uid",
          },
          { text: "Cantidad", value: "amount" },
          { text: "Estado", value: "status" },
          { text: "Codigo", value: "code" },
          { text: "Hora/Fecha", value: "created_at" },
        ]),
          (this.headersEn = [
            {
              text: "Transaction id",
              align: "start",
              value: "uid",
            },
            { text: "Amount", value: "amount" },
            { text: "Status", value: "status" },
            { text: "Code", value: "code" },
            { text: "Time/Date", value: "created_at" },
          ]);
      }
      if (this.loggedUser.locale === "es") {
        this.headers = this.headersEs;
      } else {
        this.headers = this.headersEn;
      }
    },
  },
  computed: {
    ...mapGetters(["loggedUser"]),
  },
  watch: {
    loggedUser: {
      deep: true,
      handler() {
        if (this.loggedUser.locale === "es") {
          this.headers = this.headersEs;
        } else {
          this.headers = this.headersEn;
        }
      },
    },
    itemsPerPage: {
      deep: true,
      handler() {
        this.showLoader = true;
        this.getAllQueue();
      },
    },
    page: {
      deep: true,
      handler() {
        this.showLoader = true;
        this.getAllQueue();
      },
      search: {
        deep: true,
        handler() {
          this.showLoader = true;
          this.getAllQueue();
        },
      },
      sortDesc: {
        deep: true,
        handler() {
          this.showLoader = true;
          this.getAllQueue();
        },
      },
      sortBy: {
        deep: true,
        handler() {
          if (typeof this.sortBy === "undefined") {
            this.sortBy = "created_at";
          }
          if (this.search !== "") {
            this.showLoader = true;
            this.getAllQueue();
          } else {
            this.showLoader = true;
            this.getAllQueue();
          }
        },
      },
      "$vuetify.breakpoint.name": {
        handler() {
          this.setHeader();
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.pending {
  &-label {
    font-weight: 600;
    font-size: 12px;
    line-height: inherit;
    color: #000000;
    width: 237px;
    text-align: start;
  }
}
</style>
<style>
.mobileDataTable.v-data-table td {
  padding: 0px !important;
}
.mobileDataTable .v-data-table__wrapper {
  overflow-x: hidden !important;
}
</style>